import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  advertisements: [],
  updateAdvertisements: {},
  storeAdvertisements: {},
  storeAdvertisementsImage: {},
  deleteAdvertisements: {},
};

const AdvertisementsSlice = createSlice({
  name: 'advertisements',
  initialState,
  reducers: {
    loadAdvertisementsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadAdvertisementsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.advertisements = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadAdvertisementsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateAdvertisementsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateAdvertisementsSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateAdvertisement = action.payload;
    },
    updateAdvertisementsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteAdvertisementsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteAdvertisementsSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteAdvertisement = action.payload;
    },
    deleteAdvertisementsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeAdvertisementsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeAdvertisementsSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeAdvertisement = action.payload;
    },
    storeAdvertisementsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeAdvertisementsImageRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeAdvertisementsImageSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeAdvertisementsImage = action.payload;
    },
    storeAdvertisementsImageFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadAdvertisementsRequested,
  loadAdvertisementsSuccess,
  loadAdvertisementsFail,
  updateAdvertisementsRequested,
  updateAdvertisementsSuccess,
  updateAdvertisementsFail,
  deleteAdvertisementsRequested,
  deleteAdvertisementsSuccess,
  deleteAdvertisementsFail,
  storeAdvertisementsRequested,
  storeAdvertisementsSuccess,
  storeAdvertisementsFail,
  storeAdvertisementsImageRequested,
  storeAdvertisementsImageSuccess,
  storeAdvertisementsImageFail,
} = AdvertisementsSlice.actions;

export default AdvertisementsSlice.reducer;
